import styled from '@emotion/styled'
import { Modal } from 'components/patterns'

export const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-title {
      width: 100%;
    }
    .ant-modal-body {
      padding: 25px;
      background: var(--Grey-Modal-Grey, #fbfbfb);
    }
    .ant-modal-footer {
      padding: 16px 25px;
    }
    .ant-modal-footer button {
      margin: 0;
      display: flex;
      padding: 11px 12px;
      align-items: center;
      gap: 4px;
    }
    .ant-modal-header .ant-btn svg {
      fill: var(--Slate-Dark-Slate, rgba(79, 87, 100, 0.87));
    }
  }
`

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  & h3 {
    color: rgba(7, 7, 15, 0.87);
    font-family: Arial;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }
`

export const StyledContentBody = styled.div`
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  & ul {
    padding-left: 10px;
    list-style-position: inside;
  }
  & strong,
  & b {
    color: rgba(7, 7, 15, 0.7);
    font-family: Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }
`

export const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`
